/**
 * Inline video playback for video archive cards.
 *
 * On play-button click the thumbnail is replaced by an embedded iframe
 * (YouTube or Vimeo) that autoplays immediately — matching the behaviour
 * of the live site's Elementor video widgets.
 */

/**
 * Convert a YouTube or Vimeo watch URL into an embeddable iframe src.
 *
 * @param {string} url
 * @returns {string|null}
 */
function getEmbedUrl( url ) {
    // YouTube — watch, short, embed, and shorts formats
    const yt = url.match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    if ( yt ) {
        return `https://www.youtube.com/embed/${ yt[1] }?autoplay=1&rel=0`;
    }

    // Vimeo
    const vimeo = url.match( /vimeo\.com\/(\d+)/ );
    if ( vimeo ) {
        return `https://player.vimeo.com/video/${ vimeo[1] }?autoplay=1`;
    }

    return null;
}

/**
 * Initialise inline video playback on all current and future video cards.
 * Uses event delegation so cards appended by "Load More" work automatically.
 */
export default function initVideoCards() {
    document.addEventListener( 'click', ( e ) => {
        const btn = e.target.closest( '.video-card__play-wrap[data-video-url]' );
        if ( ! btn ) return;

        e.preventDefault();

        const embedUrl = getEmbedUrl( btn.dataset.videoUrl );
        if ( ! embedUrl ) return;

        const media = btn.closest( '.video-card__media' );
        if ( ! media ) return;

        const iframe = document.createElement( 'iframe' );
        iframe.src             = embedUrl;
        iframe.className       = 'video-card__iframe';
        iframe.allow           = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title           = btn.getAttribute( 'aria-label' ) || 'Video';

        media.innerHTML = '';
        media.appendChild( iframe );
    } );
}
